module.exports = __webpack_public_path__ + "img/tower_candy.58ea4de4.jpg";